<template>
  <van-dialog
    v-model="show"
    class="dialog"
    show-cancel-button
    @close="confirm"
    @confirm="confirm"
    title="选择单位"
  >
 

    <van-list
      class="scrollList"
      :finished="true"
      :loading-text="'加载中...'"
      :finished-text="'已显示全部'"
      @load="getUnitList"
      :error="true"
      :error-click="getUnitList"
    >
      <van-cell
        ref="cell"
        v-for="item in data"
        :key="item.name"
        :title="item.name"
        @click="showActive(item)"
      />
    </van-list>
  </van-dialog>
</template>
<script>
import { queryBydic } from "../service/api/product";
export default {
  name: "unitSelect",
  components: {},
  props: {
    visible: false,
  },
  data() {
    return {
      show: false,
      data: [],
      unitList: [],
      columns: [
        {
          label: "编号",
          prop: "id",
        },
        {
          label: "名称",
          prop: "name",
        },
      ],
      currentRow: {},
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.show = newVal;
    },
  },
  created() {
    this.getUnitList();
  },
  methods: {
    showActive(item) {
      this.currentRow = item;
      const exitIndex = this.unitList.findIndex((i) => i.id === item.id);
      this.$refs.cell.forEach((el, index) => {
        el.classList.remove("active");
        if (index == exitIndex) {
          el.classList.add("active");
        }
      });
    },
    confirm() {
      this.$emit("confirm", this.currentRow);
      this.show = false;
      this.$nextTick(() => {
        this.currentRow = {};
      });
    },
    getUnitList() {
      queryBydic("SPDW").then((res) => {
        this.data = res.data;
        this.unitList = res.data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.active {
  background: #1989fa;
}
.dialog {
  height: 85%;
}

::v-deep .van-dialog__content {
  height: 100%;
  // .van-form {
  //   height: 100%;
  // }
}

.scrollList {
  height: calc(100% - 115px) !important;

  overflow: auto;
}
::v-deep .van-dialog__footer {
  position: sticky;
  bottom: 0;
}
::v-deep .van-dialog__header {
  padding-top:1rem
}
::v-deep .van-cell {
  padding: 2px 10px !important;
}
</style>
